<template>
  <div>
    <static-contact-us />
    <static-footer :pageObj="contactPage"/>
  </div>
</template>

<script>
import StaticFooter from '@/components/Footer/StaticFooter'
import StaticContactUs from '@/components/StaticPages/StaticContactUs'
import { mapGetters } from 'vuex'

export default {
  name: 'ContactUS',
  components: {
    StaticContactUs,
    StaticFooter
  },
  computed: {
    ...mapGetters([
      'all_static_pages'
    ]),
    contactPage() {
      if (this.all_static_pages) {
        return this.all_static_pages.find(page => page.slug === 'contact-us')
      }
      return {}
    },
  },
}
</script>